import {
  GET_PROJECT_TEMPLATES_REQUEST,
  DELETE_PROJECT_TEMPLATE_REQUEST,
  CLEAR_PROJECT_TEMPLATES_STATE,
  CREATE_PROJECT_TEMPLATE_REQUEST,
  INIT_REDUCER,
  CLEAR_ERRORS,
  CLEAR_ERRORS_PROFILE,
  UPDATE_PROJECT_TEMPLATE_REQUEST,
  CREATE_ERRORS,
} from './types';

const getProjectTemplates = (payload) => ({
  type: GET_PROJECT_TEMPLATES_REQUEST,
  payload,
});

const createProjectTemplate = (payload) => ({
  type: CREATE_PROJECT_TEMPLATE_REQUEST,
  payload,
});

const updateProjectTemplate = (payload) => ({
  type: UPDATE_PROJECT_TEMPLATE_REQUEST,
  payload,
});

const deleteProjectTemplate = (payload) => ({
  type: DELETE_PROJECT_TEMPLATE_REQUEST,
  payload,
});

const clearProjectTemplatesState = () => ({
  type: CLEAR_PROJECT_TEMPLATES_STATE,
});

const initReducer = () => ({
  type: INIT_REDUCER,
});

const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

const clearErrorsProfile = () => ({
  type: CLEAR_ERRORS_PROFILE,
});

const createErrors = (payload) => ({
  type: CREATE_ERRORS,
  payload: payload,
});

export {
  getProjectTemplates,
  createProjectTemplate,
  updateProjectTemplate,
  deleteProjectTemplate,
  clearProjectTemplatesState,
  initReducer,
  clearErrors,
  clearErrorsProfile,
  createErrors,
};
